<template>
  <div class="input-wrapper">
    <input
      :style="cssInputProps"
      :disabled="readOnly"
      :placeholder="placeholder"
      :type="type"
      :value="value"
      @input="onInput"
    />
  </div>
</template>

<script>
export default {
  name: 'VueInput',
  props: {
    placeholder: {
      type: String,
      default: () => 'Input...'
    },
    readOnly: {
      type: Boolean,
      default: () => false
    },
    bgColor: {
      type: String
    },
    fontSize: {
      type: String
    },
    padding: {
      type: String
    },
    borderRadius: {
      type: String
    },
    color: {
      type: String
    },
    textAlign: {
      type: String
    },
    value: {
      type: String | Number
    },
    type: {
      type: String,
      default: () => 'text'
    },
    forceUpdate: {
      type: Number,
      default: 0
    }
  },
  computed: {
    cssInputProps() {
      return {
        '--color': this.color,
        '--fontSize': this.fontSize,
        '--bgColor': this.bgColor,
        '--padding': this.padding,
        '--borderRadius': this.borderRadius,
        '--textAlign': this.textAlign
      };
    }
  },
  watch: {
    forceUpdate() {
      this.$forceUpdate();
    }
  },
  methods: {
    onInput(e) {
      this.$emit('input', e);
    }
  }
};
</script>

<style lang="scss" scoped>
::placeholder {
  color: #d6dbdd;
}
.input-wrapper {
  & > input {
    background-color: var(--bgColor, #f0f0f0);
    color: var(--color, #000d28);
    text-align: var(--textAlign, 'left');
    border-radius: var(--borderRadius, 0);
    width: var(--width, 100%);
    padding: var(--padding, 14px 0);
    font-weight: 900;
  }
}
</style>
